import React from 'react';

import { ButtonLink } from 'js/design_system/link/ButtonLink';

const AshbyJobsLoading = () => {
  return (
    <div className="roles-list-error">
      <div className="error-text">
        View and apply for our open roles on Puck.
      </div>
      <ButtonLink href="https://app.careerpuck.com/job-board/academia" external>
        View open roles on Puck
      </ButtonLink>
    </div>
  );
};

export default AshbyJobsLoading;
